import styled, { css } from 'styled-components'
import { BaseButton } from '../base/BaseButton'

export const Tabs = styled.div<{ $mt?: number }>`
  ${({ $mt }) => $mt && `margin-top: ${$mt}px;`};
  display: flex;
  justify-content: space-between;
  gap: 3px;
  background-color: #e6ebf0;
  padding: 3px;
  border-radius: 24px;
  position: relative;
  isolation: isolate;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @supports (position-anchor: --tab-item) and (top: anchor(--tab-item top)) {
    &::after {
      content: '';
      display: block;
      border-radius: 20px;
      background-color: #fefefc;
      position: absolute;
      position-anchor: --tab-item;
      inset: anchor(--tab-item top) anchor(--tab-item right) anchor(--tab-item bottom)
        anchor(--tab-item left);
      transition:
        left 0.5s
          linear(
            0,
            0.029 1.6%,
            0.123 3.5%,
            0.651 10.6%,
            0.862 14.1%,
            1.002 17.7%,
            1.046 19.6%,
            1.074 21.6%,
            1.087 23.9%,
            1.086 26.6%,
            1.014 38.5%,
            0.994 46.3%,
            1
          ),
        right 0.5s
          linear(
            0,
            0.029 1.6%,
            0.123 3.5%,
            0.651 10.6%,
            0.862 14.1%,
            1.002 17.7%,
            1.046 19.6%,
            1.074 21.6%,
            1.087 23.9%,
            1.086 26.6%,
            1.014 38.5%,
            0.994 46.3%,
            1
          );
      z-index: -1;
      will-change: left, right;
    }
  }
`

export const Tab = styled(BaseButton)<{ $active?: boolean }>`
  flex: 1 0 auto;
  min-width: max-content;
  text-wrap: nowrap;
  padding: 4px 9px;
  font-weight: 590;
  font-size: 14px;
  line-height: 19px;
  color: #000;
  border-radius: 20px;
  background-color: transparent;
  position: relative;
  scroll-snap-align: start;
  ${({ $active }) =>
    $active &&
    css`
      anchor-name: --tab-item;

      @supports (not (position-anchor: --tab-item)) or (not (top: anchor(--tab-item top))) {
        &::after {
          content: '';
          display: block;
          border-radius: 20px;
          background-color: #fefefc;
          position: absolute;
          inset: 0;
          z-index: -1;
        }
      }
    `};
`

export const TabsContent = styled.div<{ $mt?: number }>`
  ${({ $mt }) => $mt && `margin-top: ${$mt}px;`};
`
